// WhatWeProvide.js
import React from "react";
import {FaShapes, FaCode, FaBriefcase} from "react-icons/fa";
import "./WhatWeProvide.scss";

const WhatWeProvide = () => {
	const items = [
		{
			icon: <FaShapes/>,
			title: "UI Elements",
			description: "At SuperCodingBits, we make easy-to-use and good-looking UI elements for websites. You will find buttons, forms, cards and more, all ready to fit perfectly into your projects. Our designs help make your site look great and work smoothly.",
		},
		{
			icon: <FaCode/>,
			title: "Cheatsheets",
			description: "A quick guide to important code patterns, shortcuts, and best practices. At SuperCodingBits, we turn complex ideas into short, easy-to-understand snippets. Whether you use React, SCSS, or JavaScript, our cheat sheets help you code faster and smarter. They are perfect for quick development and clean, efficient coding, and always ready when you need them.",
		},
		{
			icon: <FaBriefcase/>,
			title: "Portfolio",
			description: "Explore a set of creative projects made with care and skill. At SuperCodingBits, we turn ideas into working, high-quality code. From web apps to fun experiments, our portfolio shows our focus on doing great work. Take a look and get inspired!",
		},
	];
	
	return (
		<div className="mainWhatWeProvide">
			<h2>What We Provide</h2>
			<div className="subWhatWeProvide">
				<div className="WhatWeProvide">
					{items.map ((item, index) => (
						<div className="item" key={index}>
							<div className="icon">{item.icon}</div>
							<h3>{item.title}</h3>
							<p>{item.description}</p>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default WhatWeProvide;
